<template>
  <section class="content">
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box form-inline">
          <div class="box-body">
            <div class="row">
              <div class="col-sm-6 text-left">
                <div class="form-group text-left">
                  <!--
                  <router-link :to="{path: '/crPrinter'}">
                    <div class="btn btn-default btn-table-title">新增出單機</div>
                  </router-link>
                  -->
                  <div class="form-group">
                    <select class="form-control h-38" v-model="confirmedSelect">
                      <option :value="99">== 成功對帳 ==</option>
                      <option :value="1">成功</option>
                      <option :value="0">失敗</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <select class="form-control h-38" v-model="vendorSelect">
                      <option v-for="trade in getEtradeType" :value="trade.value">
                        {{trade.label}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 text-right">
                <div class="form-group">
                  <select class="form-control h-38" v-model="searchSelect">
                    <option :value="3">訂單ID</option>
                    <option :value="1">交易編號</option>
                    <option :value="2">交易日期</option>
                  </select>
                </div>
                <div class="form-group search-bar">
                  <div class="input-group" v-if="searchSelect === 3">
                    <input class="form-control" type="text" v-model="searchResult">
                    <span class="input-group-addon c-pointer" @click="clickPage(1)"><i class="fa fa-search"></i></span>
                  </div>
                  <div class="input-group" v-if="searchSelect === 1">
                    <input class="form-control" type="text" v-model="searchResult">
                    <span class="input-group-addon c-pointer" @click="clickPage(1)"><i class="fa fa-search"></i></span>
                  </div>
                  <div class="input-group time-box" v-else-if="searchSelect === 2">
                    <date-time-picker :date="menuTime.tradeDate" :option="dateoption" :limit="tradeLimit"></date-time-picker>
                    <span class="input-group-addon c-pointer" @click="clickPage(1)"><i class="fa fa-search"></i></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                  <thead>
                  <tr role="row">
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                    <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">對帳ID</th>-->
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">交易序號 (ID)</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">訂單ID</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">金額</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">付款方式</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">交易類型</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">對帳進度</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">最後狀態</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">交易日期</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">建立時間</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">更新時間</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
                  </tr>
                  </thead>
                  <tbody v-if="isLoading">
                    <tr>
                      <td colspan="12" class="text-center">資料讀取中......</td>
                    </tr>
                  </tbody>
                  <tbody v-else-if="accountList.length > 0">
                  <tr class="even" role="row" v-for="(account, index) in accountList">
                    <!-- cloumn 0 -->
                    <td class="sorting_1">{{index + 1}}</td>
                    <td>
                      <router-link target="_blank" :to="'/cashAccountInfo/' + account.accounting_id">
                        {{account.trade_no}} ({{account.trade_id}})
                      </router-link>
                    </td>
                    <td>
                      {{account.order_id}}
                    </td>
                    <td>
                      $ {{account.money}}
                    </td>
                    <td>
                      <span v-if="account.vendor_type === 707" class="label label-success">LINE PAY</span>
                      <span v-else-if="account.vendor_type === 701" class="label label-success">iPASS MONEY</span>
                      <span v-else-if="account.vendor_type === 710" class="label label-primary">信用卡</span>
                      <span v-else-if="account.vendor_type === 713" class="label label-warning">台灣Pay</span>
                      <span v-else-if="account.vendor_type === 716" class="label label-primary">全盈+PAY</span>
                      <span v-else-if="account.vendor_type === 717" class="label label-primary">悠遊付</span>
                      <span v-else-if="account.vendor_type === 718" class="label label-info">Pi 拍錢包</span>
                      <span v-else-if="account.vendor_type === 719" class="label label-warning">全支付</span>
                      <span v-else-if="account.vendor_type === 720" class="label label-info">icash Pay</span>
                      <span v-else-if="account.vendor_type === 908" class="label label-danger">街口支付</span>
                      <span v-else-if="account.vendor_type === 909" class="label label-danger">遠傳電信代收</span>
                      <span v-else  class="label label-warning">其他</span>
                    </td>
                    <td>
                      <span v-if="account.accounting_type === 1" class="label label-success">付款</span>
                      <span v-else-if="account.accounting_type === 2"  class="label label-danger">退款</span>
                    </td>
                    <td>
                      <span v-if="account.is_confirmed" class="label label-success">已完成</span>
                      <span v-else-if="!account.is_confirmed"  class="label label-danger">未完成</span>
                    </td>
                    <td>
                      <span v-if="account.latest_status === 1"  class="label label-success">成功</span>
                      <span v-else-if="account.latest_status === 2"  class="label label-danger">失敗 訂單帳務有衝突</span>
                      <span v-else-if="account.latest_status === 3"  class="label label-danger">失敗 帳務紀錄有缺</span>
                      <span v-else-if="account.latest_status === 4"  class="label label-danger">失敗 帳務記錄冗余</span>
                      <span v-else class="label label-default">尚未對帳</span>
                    </td>
                    <td>{{account.trade_date}}</td>
                    <td>{{account.create_time}}</td>
                    <td>{{account.update_time}}</td>
                    <td>
                      <button class="btn btn-default" @click="getCurrentId(account.accounting_id, account.is_confirmed)" data-toggle="modal" data-target="#confirmModal"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                    </td>
                  </tr>
                  </tbody>
                  <tbody v-else-if="accountList.length === 0">
                  <tr style="background-color: white">
                      <td rowspan="1" colspan="12" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                        <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                        <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <paginate :pageAmount="pageAmount" :total="total" :isActive="isActive"
                        :groupAmount="groupAmount" :clickPage="clickPage" ref="brandPaginate"
              >
              </paginate>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
    <m-modal :option="confirmOption" @trigger="trigger" :selectOptions="selectOptions" @selectOnChange="selectOnChange"></m-modal>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import moment from 'moment'
export default {
  name: 'Tables',
  components: {
    'date-time-picker': datetimePicker
  },
  data () {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 10,
      searchSelect: 3,
      searchResult: '',
      accountList: [],
      confirmedSelect: 99,
      vendorSelect: 999,
      // date
      menuTime: {
        tradeDate: {
          time: moment().add(-1, 'days').format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      tradeLimit: [
        {
          type: 'fromto',
          to: moment().format('YYYY-MM-DD')
        }
      ],
      confirmOption: {
        id: 'confirmModal',
        title: '修改評分狀態',
        body: '確認修改評分狀態？',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'upConfirmed'
          }
        ]
      },
      selectOptions: {
        name: '對帳進度',
        options: [
          { text: '已完成', value: 1 },
          { text: '未完成', value: 0 }
        ]
      },
      cAccount: {
        accountId: '',
        isConfirm: '',
        newIsConfirm: 0
      },
      isLoading: true
    }
  },
  mounted () {
  },
  methods: {
    getCurrentId (accountId, isConfirm) {
      this.cAccount.accountId = accountId
      this.cAccount.isConfirm = isConfirm
    },
    upConfirmed () {
      var self = this
      var url = '/accounting/log/' + this.cAccount.accountId
      var data = {
        is_confirmed: this.cAccount.newIsConfirm
      }
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.getAccountList()
        }
      })
    },
    trigger (event) {
      if (event === 'upConfirmed') {
        this.upConfirmed()
      }
    },
    selectOnChange (value) {
      this.cAccount.newIsConfirm = value
    },
    printerType (type) {
      switch (type) {
        case 1: return '熒埔'
        case 2: return '飛鵝'
      }
    },
    clickGroup (type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1
        this.tableIndex = this.groupAmount * this.pageGroup
        this.clickPage(this.tableIndex)
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1
        this.clickPage(this.tableIndex)
      }
    },
    clickEnd (type) {
      if (type === 'pre') {
        this.clickPage(1)
        this.pageGroup = 1
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount)
        else this.clickPage(1)
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount)
      }
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    clickPage (index) {
      this.tableIndex = index
      this.getAccountList()
    },
    getAccountList () {
      this.isLoading = true
      var self = this
      var data = {
        page: this.tableIndex,
        size: this.count
      }
      var url = '/accounting/log/list?page=' + data.page + '&size=' + data.size
      if (this.searchSelect === 1 && this.searchResult) url = url + '&trade_no=' + this.searchResult
      else if (this.searchSelect === 2 && this.menuTime.tradeDate) url = url + '&trade_date=' + moment(this.menuTime.tradeDate.time, 'YYYY-MM-DD').format('YYYYMMDD')
      else if (this.searchSelect === 3 && this.searchResult) url = url + '&order_id=' + this.searchResult
      if (this.confirmedSelect !== 99) url = url + '&is_confirmed=' + this.confirmedSelect
      if (this.vendorSelect !== 999) url = url + '&vendor_type=' + this.vendorSelect
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.accountList = response.data.list
          self.total = response.data.total
          self.isLoading = false
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getRoleType', 'getEtradeType']),
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  created () {
    this.fixedH()
    this.getAccountList()
  },
  watch: {
    confirmedSelect () {
      this.clickPage(1)
    },
    vendorSelect () {
      this.clickPage(1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// CashAccountTable.vue?03ec653c